module.exports = __webpack_public_path__ + "img/stores.20ba3e29.png";